<template>
  <div class="page page-pubblication page-light p-top-header">
    <section>
      <div class="row-4-desk m-bottom-xl-1">
        <PagesCommonTextHeader
          v-if="page"
          :title="page.title"
          :intro="page?.subtitle"
          class="--align-left"
        />
      </div>
    </section>

    <PagesCommonImageVideoBlock
      :item="{
        image: page.wideMedia?.image,
        linkVideo: page.wideMedia?.videoUrl,
      }"
      class="m-bottom-m-1"
    />

    <template v-if="page.section && page.section.length > 0">
      <section v-for="sec in page.section" :key="sec.id" class="lab-section">
        <div class="row-4-desk-gradual p-top-xl-3 p-bottom-xl-2">
          <div v-for="row in sec.row" :key="row.id">
            <div class="lab-section__wrap">
              <div class="lab-section__col">
                <div
                  v-html="row.title"
                  class="lab-section__title title-m-2 m-bottom-32px"
                />
                <div
                  v-if="row.image && row.image.responsiveImage"
                  class="lab-section__image-wrap hide-for-large"
                  data-animate="block-image-preview"
                >
                  <WidgetPicture
                    class="is-cover lab-section__image-wrap"
                    :image="{ custom: row.image.responsiveImage }"
                    :lazyLoad="true"
                    :alt="row.image.responsiveImage.alt"
                  />
                </div>
                <div
                  v-html="row.text"
                  class="lab-section__text text-base-mix m-bottom-32px"
                />
              </div>
              <div class="lab-section__col">
                <div
                  v-if="row.image && row.image.responsiveImage"
                  class="lab-section__image-wrap show-for-large"
                  data-animate="block-image-preview"
                >
                  <WidgetPicture
                    class="is-cover lab-section__image-wrap"
                    :image="{ custom: row.image.responsiveImage }"
                    :lazyLoad="true"
                    :alt="row.image.responsiveImage.alt"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="sec.imageWide && sec.imageWide.responsiveImage"
            class="lab-section__image-wide-wrap"
            data-animate="block-image-preview"
          >
            <WidgetPicture
              class="is-cover lab-section__image-wide-wrap"
              :image="{ custom: sec.imageWide.responsiveImage }"
              :lazyLoad="true"
              :alt="sec.imageWide.responsiveImage.alt"
            />
          </div>
        </div>
      </section>
    </template>
    <PagesCommonExtraScrollBlock>
      <div class="extra-scroll-block__col --left">
        <p class="is-text-uppercase text-1 ">Keep scrolling<br>
        to discover our</p>
        <p class="title-base-mix extra-scroll-block__title">Research</p>
        </div>
        <div class="extra-scroll-block__col --right">
          
          <div class="extra-scroll-block__bar">
            <p class="is-text-uppercase text-1">Scroll to<br>Next page</p>
          <div class="progress-bar"><div ref="progressBar" class="progress-bar-violet" ></div></div>
            <img src="@/assets/img/ico/ico-forward-arrow.svg" alt="Next page" class="extra-scroll-block__icon"/>
          </div>
        </div>
    </PagesCommonExtraScrollBlock>
  </div>
</template>

<script setup>
import { gsap } from 'gsap'
import queries from '@/graphql/dato/queries/index.js'

//import pageTransition from '@/assets/js/transitions/helper.js'

definePageMeta({
  layout: 'default',
  //pageTransition,
})

const { locale } = useI18n()
const route = useRoute()
const router = useRouter()
const localePath = useLocalePath()

const touch = ref(false)
const matchMedia = useHelpers().evalMatchMedia('(min-width: 1100px)')


const query = queries.lab.getLab
const variables = computed(() => ({
  locale: locale.value,
}))

const staggeredBlocksShown = ref(false)
const duration = 0.6
const durationFast = 0.4
const ease = 'power2.inOut'

const { data } = await useGraphql(query, variables)

if (!data.value?.lab) {
  throw createError({ statusCode: 404 })
}
const page = computed(() => data.value?.lab)
const seo = computed(() => data.value?.lab?.seo || {})
const pubblications = computed(() => data.value?.allPubblications)


let extraScroll = 0; // Contatore per lo scroll extra
const SCROLL_THRESHOLD = ref(500); // Soglia di 300 px virtuali
const isTransitioning = ref(false)
const extraScrollPercentage = ref(0)
let touchStartY = 0

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints
  window.addEventListener('wheel', handleScroll);
window.addEventListener('touchmove', handleScroll, { passive: false }); // Per dispositivi mobili
 window.addEventListener('touchstart', (event) => {
    touchStartY = event.touches[0].clientY;
  })
})

onBeforeUnmount(() => {
  window.removeEventListener('wheel', handleScroll);
  window.removeEventListener('touchmove', handleScroll);
  window.removeEventListener('touchstart', () => {})
})

onUnmounted(() => {})

// Seo
useSeo({
  ...seo.value,
})

watch(
  () => route.path,
  () => {}
)

const handleScroll = (event) => {
  const baretta = document.querySelector('.progress-bar-violet')
 // console.log('dentro handleSCroll')
  const scrollPosition = window.innerHeight + window.scrollY;
  const documentHeight = document.documentElement.scrollHeight;

  //console.log(scrollPosition, documentHeight)


  if (scrollPosition >= documentHeight - 5 && !isTransitioning.value) {
    // L'utente è al fondo: registra il movimento di scroll extra
   let scrollDelta = 0;

    // Determina il delta per il movimento del mouse (wheel) o touch (touchmove)
    if (event.type === 'wheel') {
      scrollDelta = event.deltaY; // movimento della rotella del mouse
    } else if (event.type === 'touchmove') {
      const touch = event.touches[0];
    scrollDelta = touchStartY - touch.clientY;
    touchStartY = touch.clientY // movimento del tocco su dispositivi mobili
    }

    if (touch.value) {
      SCROLL_THRESHOLD.value = 100
    }

    // Accumula lo scroll extra
    extraScroll += scrollDelta;
    //console.log(extraScroll, extraScrollPercentage.value)
    extraScrollPercentage.value = Math.min(100, (extraScroll / SCROLL_THRESHOLD.value) * 100)

      // Riempi la progress bar in base allo scroll extra
      gsap.to(baretta, {
        width: `${extraScrollPercentage.value}%`,
        duration: 0.1,
      })

    if (extraScroll >= SCROLL_THRESHOLD.value ) {
      //console.log('dentro if extra scroll')
      // Cambia pagina e resetta il contatore
       gsap.to(baretta, {
        width: `100%`,
        duration: 0.1,
        onComplete: ()=>{
          isTransitioning.value = true;
            setTimeout(() => {
            router.push(localePath({name: 'research'}));
          }, 500)
        }
      })
        
      
       if (extraScrollPercentage.value >= 100) {
         // Sostituisci '/next-page' con il percorso desiderato
      }
       // Ritardo per l'animazione (0.5s corrisponde a .page-fade)
    }
  } else {
    // Resetta il contatore se l'utente scrolla verso l'alto o non è al fondo
    extraScroll = 0;
    extraScrollPercentage.value = 0
    gsap.to(baretta, {
        width: `${extraScrollPercentage.value}%`,
        duration: 0.1,
      })
  }
}
</script>
